import { render } from "./InconsistenciesView.vue?vue&type=template&id=ac23a2be"
import script from "./InconsistenciesView.vue?vue&type=script&lang=js"
export * from "./InconsistenciesView.vue?vue&type=script&lang=js"

import "./InconsistenciesView.vue?vue&type=style&index=0&id=ac23a2be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__